<template>
  <div v-if="info.title" class="contract-fill-item">
    <div class="contract-sub-title">{{ info.title }}</div>
    <div
      class="input fill-input"
    >
      {{ info.content || '&nbsp;' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContractPhone',

  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isStartGenerate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getSubmitData() {
      return {
        callUs: this.info.content
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.contract-fill-item {
  margin-top 30px
  .fill-input {
    margin-top 10px
    border-radius: 4px
    width: 90%
    font-size 16px
    padding 4px 0
    border: 1px solid #eee
    padding-left: 10px 
  }
}
.contract-sub-title {
  font-size: 16px
  font-weight: bold
}
</style>
